import React from 'react';
import './styles.css';

const CheckboxSelectItem = ({ item, group, checked }) => (
  <div
    className={
      group
        ? 'checkbox-select-item checkbox-select-item--group'
        : 'checkbox-select-item'
    }
  >
    {!group && (
      <span
        className={
          checked
            ? 'checkbox-select-item__checkmark checkbox-select-item__checkmark--checked'
            : 'checkbox-select-item__checkmark'
        }
      />
    )}

    <div className="checkbox-select-item__caption">
      {item.label.length > 45
        ? [...(item.label.substring(0, 45) + '... ')]
        : item.label}
    </div>
  </div>
);

export default CheckboxSelectItem;
